import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { Note } from '../models/Note';

@Injectable({ providedIn: 'root' })

export class NoteService { 
  private _ENDPOINT = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/notes';   
  }

  /** GETALL: get all records from the server */
  getAll(contentId: number, contentType: number, total: number): Observable<Array<Note>> {
    return this.http.get<Array<Note>>(this._ENDPOINT + '?contentId=' + contentId + '&contentType=' + contentType + '&total=' + total);
  }

/** GETBYID: get single record from the server */
  getById(id: any): Observable<Note> {
    const url = this._ENDPOINT+'/'+id;
    return this.http.get<Note>(url);
  }

  /** POST: add a new note to the server */
  add(note: Note): Observable<Note> {
    return this.http.post<Note>(this._ENDPOINT, note, this.httpOptions).pipe(
      tap((newNote: Note) => this.log('added note w/ id=${newNote.id}')),
      catchError(this.handleError<Note>('add'))
    );
  }

  /** DELETE: delete the note from the server */
  delete(note: Note | number): Observable<Note> {
    const id = typeof note === 'number' ? note : note.id;
    const url = this._ENDPOINT + '/' + id;

    return this.http.delete<Note>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted note id=${id}')),
      catchError(this.handleError<Note>('delete'))
    );
  }

  /** PUT: update the note on the server */
  update(id: number, note: Note): Observable<any> {
    return this.http.put(this._ENDPOINT + "/" + id, note , this.httpOptions).pipe(
      tap(_ => this.log('updated note id=${note.Id}')),
      catchError(this.handleError<any>('update'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a NoteService message with the MessageService */
  private log(message: string) {
    this.messageService.add('NoteService: ${message}');
  }
}
